import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { HiDownload, HiSun, HiMoon, HiMenu, HiX } from "react-icons/hi";

const NAV_LINKS = [
  { href: "#about", label: "About" },
  { href: "#experience", label: "Experience" },
  { href: "#projects", label: "Projects" },
  { href: "#skills", label: "Skills" },
  { href: "#education", label: "Education" },
  { href: "#contact", label: "Contact" },
];

function Navbar({ theme, toggleTheme }) {
  const [activeSection, setActiveSection] = useState("hero");
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);

      // Check if at the bottom of the page
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 80
      ) {
        setActiveSection("contact");
        return;
      }

      // Scroll spy for active section highlight
      const sections = [
        "contact",
        "education",
        "skills",
        "projects",
        "experience",
        "about",
        "hero",
      ];
      const scrollThreshold = window.scrollY + 220;

      for (const sectionId of sections) {
        const el = document.getElementById(sectionId);
        if (el) {
          const absoluteTop = el.getBoundingClientRect().top + window.scrollY;
          if (scrollThreshold >= absoluteTop) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className={`navbar-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container nav-container">
        {/* Brand / Logo */}
        <a href="#hero" className="nav-brand" onClick={closeMenu}>
          <span className="brand-badge">PK</span>
          <span className="brand-text">Prasanna Kumar</span>
        </a>

        {/* Desktop Navigation */}
        <nav className="desktop-nav" aria-label="Main Navigation">
          <ul className="nav-links">
            {NAV_LINKS.map((link) => {
              const targetId = link.href.substring(1);
              const isActive = activeSection === targetId;
              return (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className={`nav-link ${isActive ? "active" : ""}`}
                    aria-current={isActive ? "page" : undefined}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Action Controls */}
        <div className="nav-actions">
          {/* Theme Toggle */}
          <button
            className="theme-toggle-btn"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
            title={theme === "dark" ? "Light theme" : "Dark theme"}
          >
            {theme === "dark" ? <HiSun size={20} /> : <HiMoon size={20} />}
          </button>

          {/* Download Resume Button */}
          <a
            href="/resume.pdf"
            download="Prasanna_Kumar_Resume.pdf"
            className="btn-nav-resume"
            aria-label="Download resume PDF"
          >
            <HiDownload size={16} />
            <span>Resume</span>
          </a>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-toggle-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation menu"
          >
            {mobileMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {mobileMenuOpen && (
        <div className="mobile-drawer">
          <ul className="mobile-links">
            {NAV_LINKS.map((link) => {
              const targetId = link.href.substring(1);
              const isActive = activeSection === targetId;
              return (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className={`mobile-link ${isActive ? "active" : ""}`}
                    onClick={closeMenu}
                  >
                    {link.label}
                  </a>
                </li>
              );
            })}
            <li className="mobile-resume-item">
              <a
                href="/resume.pdf"
                download="Prasanna_Kumar_Resume.pdf"
                className="btn-nav-resume mobile-resume-btn"
                onClick={closeMenu}
              >
                <HiDownload size={18} />
                <span>Download Resume</span>
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Navbar;
